import { createStyles,makeStyles } from "@material-ui/core";
import React from "react";

const MapService: any = { current: null };
const DirectionRenderService: any = { current: null };
const DirectionService: any = { current: null };
const icons = () => ({
  start: new (window as any).google.maps.MarkerImage(
    // URL
    "/assets/icons/deleveryIcon.svg",
    // (width,height)
    new (window as any).google.maps.Size(44, 32),
    // The origin point (x,y)
    new (window as any).google.maps.Point(0, 0),
    // The anchor point (x,y)
    new (window as any).google.maps.Point(22, 32)
  ),
  end: new (window as any).google.maps.MarkerImage(
    // URL
    "/assets/icons/pickupIcon.svg",
    // (width,height)
    new (window as any).google.maps.Size(44, 32),
    // The origin point (x,y)
    new (window as any).google.maps.Point(0, 0),
    // The anchor point (x,y)
    new (window as any).google.maps.Point(22, 32)
  ),
});

export interface GoogleMapProps {
  id: string;
  options?: {};
  onMapLoad?: (map: any) => void;
  orgin?: any;
  destination?: any;
  travelMode?: string;
}

const useStyles = makeStyles(() =>
  createStyles({
    mapStyle: {
      width: 472, 
      height: 928 
    },
  }));

export function GoogleMap({ onMapLoad, ...props }: GoogleMapProps) {
  const style = useStyles();
  React.useEffect(() => {
    initializeServices(props);
  }, [props]);
  return (
    <>
      <div className={style.mapStyle} id={props.id} />
    </>
  );
}

function initializeServices({ onMapLoad, ...props }: GoogleMapProps) {
  if (!(window as any).google) {
    return;
  }

  if (!MapService.current) {
    DirectionService.current = new (window as any).google.maps.DirectionsService();
    DirectionRenderService.current = new (window as any).google.maps.DirectionsRenderer({
      suppressMarkers: true,
      polylineOptions: {
        strokeColor: "#399EBF",
      },
    });
  }

  MapService.current = new (window as any).google.maps.Map(document.getElementById(props.id), props?.options);

  onMapLoad && onMapLoad(MapService.current);
  loadGoogleMap(props);
}

function loadGoogleMap(props: GoogleMapProps) {
  if (MapService.current && props?.orgin && props?.destination) {
    DirectionRenderService.current?.setMap(MapService.current);
    DirectionService.current.route(
      {
        origin: { placeId: props?.orgin },

        destination: { placeId: props?.destination },
        //   @ts-ignore
        travelMode: google.maps.TravelMode.DRIVING,
      },
      (response: any, status: any) => {
        if (status === "OK") {
          const leg = response.routes[0].legs[0];
          DirectionRenderService?.current?.setDirections(response);
          addMarker(leg.start_location, icons().start, leg.start_address, MapService.current);
          addMarker(leg.end_location, icons().end, leg.end_address, MapService.current);
        }
      }
    );
  }
}

function addMarker(position: any, icon: any, title: string, map: any) {
  const marker = new (window as any).google.maps.Marker({
    position,
    map,
    icon,
    title,
  });

  const infowindow = new (window as any).google.maps.InfoWindow({
    content: `<div> ${title} </div>`,
  });

  marker.addListener("mouseover", () => {
    infowindow.open(map, marker);
  });
  marker.addListener("mouseout", () => {
    infowindow.close(map, marker);
  });
}

